export default __webpack_public_path__ + "static/media/Banner2.9d6ab767.jpg";